<div mat-dialog-title>
  <h1 class="title">{{ title }}</h1>
</div>

<div mat-dialog-content>

    <div class="dialog-message">
      <mat-icon [ngClass]="iconClass" class="dialog-icon">
        {{ icon }}
      </mat-icon>
      <small class="subtitle" [innerHTML]="message"></small>
    </div>

</div>

<div mat-dialog-actions align="end">
  <button matButton="outlined" class="secondary-button" mat-dialog-close>Cerrar</button>
</div>